import React, { useState } from "react";
import {
  Button,
  EmployeeHeader,
  NewTab,
  PageHeader,
  PageTab,
} from "../../../../components";
import DocumentsTab from "./Documents/DocumentsTab";
import W4Form from "./Documents/W4Form";
import W2 from "./Documents/W2";
import Tab1099 from "./Documents/Tab1099";
import ClientDocuments from "./Documents/ClientDocuments";
import VendorDocumets from "./Documents/VendorDocumets";
import DocumentModal from "./Documents/DocumentModals/DocumentModal";
import AddBulkModal from "./Documents/DocumentModals/AddBulkModal";
import W4FormModal from "./Documents/DocumentModals/W4FormModal";
import W2Modal from "./Documents/DocumentModals/W2Modal";
import Tab1099Modal from "./Documents/DocumentModals/Tab1099Modal";
import ClientDocumentsModal from "./Documents/DocumentModals/ClientDocumentsModal";
import VendorDocumetsModal from "./Documents/DocumentModals/VendorDocumetsModal";
import { useNavigate } from "react-router-dom";

const Documents = () => {
  const [activeModal, setActiveModal] = useState(null);
  const navigate = useNavigate();

  const handleOpenModal = (modalType) => {
    setActiveModal(modalType);
  };

  const handleCloseModal = () => {
    setActiveModal(null);
  };

  const ModalComponents = {
    // workAuthorization: WorkAuthorizationModal,
    // passport: PassportModal,
    // 194: I94Modal,
    // 140: I40Modal,
    // eVerifiy: EVerifyModal,
    documents: DocumentModal,
    addBulk: AddBulkModal,
    w4Form: W4FormModal,
    w2: W2Modal,
    tab1099: Tab1099Modal,
    clientDocuments: ClientDocumentsModal,
    vendorDocumets: VendorDocumetsModal,
  };

  const renderActiveModal = () => {
    if (!activeModal) return null;

    const ModalComponent = ModalComponents[activeModal];
    return <ModalComponent isOpen={true} onClose={handleCloseModal} />;
  };

  const DocumentsMenus = [
    {
      title: "Documents",
      page: <DocumentsTab />,
      type: "main",
      subTabs: [
        {
          title: "Add",
          icon: "add",
          action: () => handleOpenModal("documents"),
        },
        {
          title: "Add Bulk",
          icon: "add",
          action: () => handleOpenModal("addBulk"),
        },
      ],
    },

    {
      title: "W-4",
      page: <W4Form />,
      type: "main",
      subTabs: [
        {
          title: "Add",
          icon: "add",
          action: () => handleOpenModal("w4Form"),
        },
      ],
    },
    {
      title: "W-2",
      page: <W2 />,
      type: "main",
      subTabs: [
        {
          title: "Add",
          icon: "add",
          action: () => handleOpenModal("w2"),
        },
      ],
    },
    {
      title: "1099",
      page: <Tab1099 />,
      type: "main",
      subTabs: [
        {
          title: "Add",
          icon: "add",
          action: () => handleOpenModal("tab1099"),
        },
      ],
    },
    {
      title: "Client Documents",
      page: <ClientDocuments />,
      type: "main",

      subTabs: [
        {
          title: "Add",
          icon: "add",
          action: () => handleOpenModal("clientDocuments"),
        },
      ],
    },
    {
      title: "Vendor Documets",
      page: <VendorDocumets />,
      type: "main",

      subTabs: [
        {
          title: "Add",
          icon: "add",
          action: () => handleOpenModal("vendorDocumets"),
        },
      ],
    },
  ];
  return (
    <div className="mt-3 flex-1 flex flex-col gap-2 ">
      <div>
        <PageHeader
          Section={<EmployeeHeader />}
          RightSection={
            <div className="flex gap-3">
              <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                type="link"
                to="/employee"
              />
              {/* <Button
                size="sm"
                title={"Back"}
                icon={"west"}
                // onClick={() =>
                //   navigate("/employee/employee-profile#placements")
                // }
                onClick={() =>
                  navigate(
                    "/employee/employee-profile?placements=placements&profile-info=placements",
                  )
                }
              />
              <Button
                size="sm"
                title={"Next"}
                icon={"east"}
                iconPosition="after"
                // onClick={() =>
                //   navigate("/employee/employee-profile#confidential")
                // }
                onClick={() =>
                  navigate(
                    "/employee/employee-profile?profile-info=confidential",
                  )
                }
              /> */}
            </div>
          }
        />
      </div>
      <div>
        <NewTab
          tabs={DocumentsMenus}
          color="black"
          variant="outlined"
          mode="url"
          tabId="documents"
        />
      </div>
      {renderActiveModal()}
    </div>
  );
};

export default Documents;
